<div class="definition-editor">
  <label class="wk-field-label" for="definitionEditorData"
    >{{ 'APP.KEYWORDS_DEFINITION.DEFINITION' | translate }}
  </label>
  <wk-ckeditor
    [config]="definitionPlugins"
    [(ngModel)]="definitionEditorData"
    [editor]="wkDefinitionEditor"
    (ready)="onReady()"
    (editorChange)="onChange()"
    (insertlink)="onInsertLink($event)"
    (openContextMenu)="openContextMenu($event)"
    (routeToLink)="routeToLink($event)"
    #definitionEditor
  >
  </wk-ckeditor>
  <wk-context-menu-editor
    *ngIf="loadContextMenuComponent"
    [contextMenuObject]="contextMenuObject"
  ></wk-context-menu-editor>
</div>
